import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';
import { ErrorBoundary } from '../ui/ErrorBoundary';

const titleByPath: Record<string, string> = {
  '/': 'Overview',
  '/jira': 'Jira',
  '/security': 'Security',
  '/repositories': 'Repositories',
  '/sites': 'Sites',
  '/infrastructure': 'Infrastructure',
  '/playbooks': 'Playbooks',
  '/compliance': 'Compliance',
};

function resolveTitle(pathname: string): string {
  if (titleByPath[pathname]) return titleByPath[pathname];
  const base = '/' + pathname.split('/')[1];
  return titleByPath[base] ?? 'Health Academy Pulse';
}

export function DashboardLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-screen bg-surface-light dark:bg-surface-dark">
      <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />
      <div className="flex min-h-screen flex-1 flex-col lg:w-[calc(100%-16rem)]">
        <TopNav onOpenMobileNav={() => setMobileNavOpen(true)} title={resolveTitle(pathname)} />
        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
